import { getErrorMessage } from './errors';
import { notifyError } from '../lib/notifications';

export const notifyOnError = async (
  queryFulfilled: Promise<unknown>,
  fallback?: string,
): Promise<void> => {
  try {
    await queryFulfilled;
  } catch (error) {
    const inner = (error as { error?: unknown }).error ?? error;
    notifyError(getErrorMessage(inner, fallback));
  }
};
